import React, { useState } from 'react';
import { Modal, Button} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';



const AddExternalycase = ({ showModal, handleClose }) => {
  
 
  const [inputValuer, setInputValuer] = useState('');
  const handleInputChanger = (event) => {
    setInputValuer(event.target.value);
  };
  const [inputValueded, setInputValueded] = useState('');
  const handleInputChangeded= (event) => {
    setInputValueded(event.target.value);
  };
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  const inputStyling = {
    padding: '8px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '250px',
    height: "35px",
    marginLeft: "90px"
  };
  const inputStyled = {
    padding: '8px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '250px',
    height: "35px",
    marginLeft: "90px"
  };
  const inputStyleded = {
    padding: '8px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '250px',
    height: "35px",
    marginLeft: "90px"
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w" centered size="lg">
        <Modal.Header closeButton  style={{ backgroundColor: '#004aad' }}>
          <Modal.Title className='heading' style={{ color: 'white' }}>  Link External File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h5>External Link</h5>
            <div style={{
            alignItems: 'center',
            fontSize: '0.9rem',
            marginRight: '20px',
            gap: '50px',
            backgroundColor: '#f2f2f2'
          }}>
            <br/>
<b style={{marginLeft:"10px"}}>Link *</b>   <input
                  type="text"
                  value={inputValuer}
                  onChange={handleInputChanger}
                  style={inputStyling}
                  placeholder='e.g.https://external.com/file.jpg'
                /> 
                <br></br>
                <br></br>
<b style={{marginLeft:"10px"}}>Name </b> 
 <input
                  type="text"
                  value={inputValueded}
                  onChange={handleInputChangeded}
                  style={inputStyleded}
                  placeholder='Name of Link'
                />

<br></br>
<br></br>
<b style={{marginLeft:"10px"}}>Desc. </b>  <input
                  type="text"
                  value={inputValue}
                  onChange={handleInputChange}
                  style={inputStyled}
                  placeholder='Extended description of Link'
                />  
                 <br/>
                 <br/>
</div>
        </Modal.Body>
        <div style={{ position: 'relative',paddingBottom:"50px" }}>
  <Button
    variant="secondary"
    onClick={handleClose}
    style={{
      backgroundColor: '#004aad',
      borderColor: '#004aad',
    
    marginLeft:"690px"
    }}
  >
    Cancel
  </Button>

  <Button
    variant="secondary"
    onClick={handleClose}
    style={{
      backgroundColor: '#004aad',
      borderColor: '#004aad',
      position: 'absolute',
      right: '120px' // Adjust as needed to space the buttons
    }}
  >
    Save
  </Button>
</div>
      </Modal>
     
    </div>
   
  );
};

export default AddExternalycase;
